var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgParking = function SvgParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#244D5A",
    strokeWidth: 1.5,
    d: "M24 6.75H10A3.25 3.25 0 0 0 6.75 10v13A3.25 3.25 0 0 0 10 26.25h14A3.25 3.25 0 0 0 27.25 23V10A3.25 3.25 0 0 0 24 6.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#244D5A",
    d: "M14.536 22.488V17.72h1.872c2.928 0 4.4-1.088 4.4-3.392 0-2.256-1.424-3.328-4.272-3.328H13v11.488zm0-6.08v-4.064h2.128c1.728 0 2.624.624 2.624 1.984 0 1.872-1.552 2.08-2.768 2.08z"
  })));
};
export default SvgParking;